import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DealerList from "../../features/manageDealers/dealerList";
import { Button } from "@mui/material";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { useGetShowroomsQuery } from "../../service/showroom/api";

const ManageDealers = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  const { data, isLoading } = useGetShowroomsQuery({ page, limit: 10, search: searchTerm });

  const showrooms = data?.data?.data || [];
  const paginator = data?.data?.paginator || null;

  return (
    <>
      <CommonBreadcrumb
        title="Showrooms Management"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Showrooms Management" },
        ]}
      />
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Showroom"
            />

          </div>
          <div className="right_s">
            <Button className="btn btn_primary"><FileDownloadOutlinedIcon /> Export CSV</Button>
            <Button className="btn btn_primary" onClick={() => navigate('/manage-dealers/add')}><AddIcon /> Add Showroom</Button>
          </div>
        </div>
        <DealerList
          showrooms={showrooms}
          page={page}
          setPage={setPage}
          paginator={paginator}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default ManageDealers;
